import { useTranslation } from 'react-i18next'

import { CardDashboard } from '@percent/lemonade'
import { EffectiveRolesList, type EffectiveRolesListProps } from '@percent/domain/iam'

export function EffectiveRolesCard(props: Readonly<Omit<EffectiveRolesListProps, 'emptyTitle'>>) {
  const { t } = useTranslation()

  return (
    <CardDashboard title={t('effectiveRoles.title')} headingLevel="h4">
      <EffectiveRolesList {...props} emptyTitle={t('effectiveRoles.empty')} />
    </CardDashboard>
  )
}
